export default "__VITE_ASSET__DwsnvQql__";